//This function holds some data for the mock exercises we have currently

export default function ExercisesData() {
      
    return [{    
        exerciseName: "Jumping Jacks",
        reps: "30 reps",
        id: "Jumping Jacks",
        },
        {    
        exerciseName: "Push-Ups",
        reps: "20 reps",
        id: "Push-Ups",
        },
        {    
        exerciseName: "Crunches",
        reps: "30 reps",
        id: "Crunches",
        },
        {    
        exerciseName: "Step-Ups",
        reps: "20 reps",
        id: "Step",
        },
        {    
        exerciseName: "Squats",
        reps: "30 reps",
        id: "Squats",
        },
        {    
        exerciseName: "Tricep Dips",
        reps: "20 reps",
        id: "Tricep Dips",
        },
        {    
        exerciseName: "Mountain Climbers",
        reps: "30 reps",
        id: "Tricep Dips",
        },
        {    
        exerciseName: "Plank Frog Jumps",
        reps: "30 reps",
        id: "Plank Frog Jumps",
        },
        {    
        exerciseName: "Commando",
        reps: "30 reps",
        id: "Commando",
        },
    ];
 }


           